import type { Dispatch } from 'redux';
/**
 * replaces redux store.dispatch for testing purposes
 * one have to mock this function
 */
export const disposeDispatch = (_store: { dispatch: Dispatch }) => {
	// there is no implementation for this function
	// is it expected to be overridden in tests
};
